module.exports = __webpack_public_path__ + "static/media/iconXWhite.dca055a2.svg";